import { render, staticRenderFns } from "./surfaceOff.vue?vue&type=template&id=2c7801a6&"
import script from "./surfaceOff.vue?vue&type=script&lang=ts&"
export * from "./surfaceOff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports